import { BottomNavigation, Button, ListItemAvatar } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import useTheme from '@material-ui/core/styles/useTheme';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { ArrowBack, Assistant, Help, Publish, SupervisorAccount } from '@material-ui/icons';
import Add from '@material-ui/icons/Add';
import Brightness4 from '@material-ui/icons/Brightness4';
import Brightness7 from '@material-ui/icons/Brightness7';
import Business from '@material-ui/icons/Business';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ExitToApp from '@material-ui/icons/ExitToApp';
import FormatListBulleted from '@material-ui/icons/FormatListBulleted';
import GetApp from '@material-ui/icons/GetApp';
import Home from '@material-ui/icons/Home';
import LocalOffer from '@material-ui/icons/LocalOffer';
import Menu from '@material-ui/icons/Menu';
import People from '@material-ui/icons/People';
import Person from '@material-ui/icons/Person';
import Search from '@material-ui/icons/Search';
import { Alert } from '@material-ui/lab';
import useLocalStorage, { writeStorage } from '@rehooks/local-storage';
import clsx from 'clsx';
import firebase from 'firebase/app';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Link, Prompt, useHistory, useLocation } from 'react-router-dom';

import { Collections } from 'Collections';
import { analytics, auth, db } from 'FirebaseConfigs';
import { LocalStorageKeys } from 'LocalStorageKeys';
import { AnalyticsEvent } from 'models/AnalyticsEvent';
import { AppRoles } from 'models/AppRoles';
import { AppUser, noAppUserNameText } from 'models/AppUser';
import { noEmailText } from 'models/Email';
import { noOrgNameText, Org } from 'models/Org';
import { OrgRoles } from 'models/OrgRoles';
import { OrgUser } from 'models/OrgUser';
import { Paths } from 'Paths';
import { WarningModal } from 'screens/Users/OrgUserScreen';
import { OrgUserInviteModal } from 'screens/Users/OrgUsersScreen';

import { useAddToHomeScreen } from './AddToHomeScreen';
import { useAppUser } from './AppUserProvider';
import { FullscreenLoading } from './FullscreenLoading';
import { useOrg, useOrgIdLocalStorage, useUnselectOrg } from './OrgProvider';
import { useOrgUser } from './OrgUserProvider';

//Also change the <Hidden> tag size in the SideDrawer component when changing this
export const responsiveDrawerDeviceSize = "sm";
export const drawerWidth = 250;

type StyleProps = {
    openLeft?: boolean
    openRight?: boolean
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles<string, StyleProps>({
        root: {
            display: 'flex',
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        bottomAppBar: {
            marginLeft: ({ openLeft }) => openLeft ? drawerWidth : 0,
            marginRight: ({ openRight }) => openRight ? drawerWidth : 0,
            [theme.breakpoints.up("md")]: {
                width: ({ openLeft }) => `calc(100% - ${(openLeft) ? 0 : theme.spacing(8) + 1}px)`,
            },
        },
        appBarShift: {
            marginLeft: ({ openLeft }) => openLeft ? drawerWidth : 0,
            marginRight: ({ openRight }) => openRight ? drawerWidth : 0,
            width: ({ openLeft, openRight }) => `calc(100% - ${((openLeft && openRight) ? 2 : 1) * drawerWidth}px)`,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        menuButton: {
            '&:first-child': {
                marginLeft: -theme.spacing(2),
                marginRight: theme.spacing(2),
            },
            '&:last-child:not(:only-child)': {
                marginLeft: theme.spacing(2),
            },
        },
        hide: {
            [theme.breakpoints.up(responsiveDrawerDeviceSize)]: {
                //Consider adding transition that hides buttons
                //display: 'none',
            }
        },
        title: {
            marginLeft: 'auto',
            marginRight: 'auto',
        },
        drawer: {
            [theme.breakpoints.up(responsiveDrawerDeviceSize)]: {
                width: drawerWidth,
                flexShrink: 0,
                whiteSpace: 'nowrap',
            },
        },
        drawerPaper: {
            borderRight: 0,
            borderLeft: 0,
            padding: 1,
        },
        drawerOpen: {
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerClose: {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            width: theme.spacing(8) + 1,
        },
        toolbar: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: theme.spacing(0, 1),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
        },
        toolbarPaper: {
            backgroundColor: '#388e3c',
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            margin: -1,
        },
        rightToolbarPaper: {
            borderBottomRightRadius: 0,
        },
        rightDrawerTitle: {
            marginRight: 'auto',
            marginLeft: theme.spacing(1),
        },
        content: {
            flexGrow: 1,
            width: `calc(100% - ${theme.spacing(9) + 1}px)`,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        contentShift: {
            width: ({ openLeft, openRight }) => `calc(100% - ${((openLeft && openRight) ? 2 : 1) * drawerWidth}px)`,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        search: {
            position: 'relative',
            borderRadius: theme.shape.borderRadius,
            backgroundColor: fade(theme.palette.common.white, 0.15),
            '&:hover': {
                backgroundColor: fade(theme.palette.common.white, 0.25),
            },
            marginLeft: 0,
            width: '100%',
            [theme.breakpoints.up('sm')]: {
                marginLeft: theme.spacing(1),
                width: 'auto',
            },
        },
        searchIcon: {
            padding: theme.spacing(0, 2),
            height: '100%',
            position: 'absolute',
            pointerEvents: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        inputRoot: {
            color: 'inherit',
        },
        inputInput: {
            padding: theme.spacing(1, 1, 1, 0),
            // vertical padding + font size from searchIcon
            paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
            transition: theme.transitions.create('width'),
            width: '100%',
            [theme.breakpoints.up('sm')]: {
                width: '12ch',
                '&:focus': {
                    width: '20ch',
                },
            },
        },
        blackText: {
            color: 'rgb(0,0,0,0.87)',
        },
    }),
);

type AccessRestrictionMap = { orgRoles?: OrgRoles.OrgRole[], appRoles?: AppRoles.AppRole[], requireOrgUser?: boolean, requireOrg?: boolean }
type NavMenuOptionDescription = [icon: React.ReactNode, label: string, path: string, roles?: AccessRestrictionMap]
type NavMenuOption = JSX.Element | NavMenuOptionDescription

enum NavMenuSubOptions {
    ORG = 'ORG',
    USER = 'USER',
    ADMIN = 'ADMIN',
}

type NavMenuSubOption = [
    optionKey: NavMenuSubOptions,
    menuToggleDesc: NavMenuOptionDescription,
    subOptions: NavMenuOption[],
    numExtraOptions?: number,
]

function isNavMenuOption(entry: NavMenuOptionDescription | NavMenuSubOption): entry is NavMenuOptionDescription {
    return !Array.isArray(entry[1])
}

function checkOptionAvailable(roles?: AccessRestrictionMap, org?: Org, orgUser?: OrgUser, appUser?: AppUser) {
    return !((roles?.requireOrg && !org)
        || (roles?.requireOrgUser && !orgUser)
        || (roles?.orgRoles && (!orgUser || roles?.orgRoles?.some(role => !orgUser?.orgRoles.map?.[role])))
        || (roles?.appRoles && (!appUser || roles?.appRoles?.some(role => !appUser?.appRoles.map?.[role]))))
}

function items(pathname: string, openMenus: NavMenuSubOptions[], setOpenMenus: (openMenus: NavMenuSubOptions[]) => void, isMini: boolean, orgUser?: OrgUser, appUser?: AppUser, org?: Org) {
    const list: (NavMenuOption | NavMenuSubOption)[] = [
        [<Home />, 'Startside', Paths.DASHBOARD.replace('/', '')],
        [<LocalOffer />, 'Anbud', Paths.OFFER.replace('/', ''), { requireOrg: true }],
        [<LocalOffer />, 'Utkast', Paths.OFFER_DRAFTS.replace('/', ''), { requireOrg: true }],
        [<Add />, 'Opprett Anbud', Paths.CREATE_OFFER.replace('/', ''), { requireOrgUser: true }],
        [
            NavMenuSubOptions.USER,
            [<Person />, 'Bruker', ''],
            [
                [<Person />, 'Min App-Bruker', Paths.MY_APP_USER.replace('/', '')],
                [<Person />, 'Min Org-Bruker', Paths.MY_ORG_USER.replace('/', ''), { requireOrgUser: true }],
            ],
            1,
        ],
        [
            NavMenuSubOptions.ORG,
            [<Business />, 'Organisasjon', ''],
            [
                [<FormatListBulleted />, 'Prisfelter', Paths.PRICE_FIELDS.replace('/', ''), { requireOrg: true }],
                [<FormatListBulleted />, 'Maler', Paths.PRICE_FIELD_TEMPLATES.replace('/', '')],
                [<FormatListBulleted />, 'Forslag til Maler', Paths.PRICE_FIELD_TEMPLATE_SUGGESTIONS.replace('/', '')],
                [<People />, 'Ansatte', Paths.ORG_USERS.replace('/', ''), { requireOrg: true }],
                <OrgUserInviteModal pageNavMode />,
                [<Person />, 'Min Org-Bruker', Paths.MY_ORG_USER.replace('/', ''), { requireOrgUser: true }],
                [<Business />, 'Min Organisasjon', 'min-organisasjon', { orgRoles: [OrgRoles.FlatEnum.OWNER] }],
            ],
        ],
        [
            NavMenuSubOptions.ADMIN,
            [<SupervisorAccount />, 'Administrator', ''],
            [
                [<People />, 'App-Brukere', Paths.APP_USERS.replace('/', ''), { appRoles: [AppRoles.FlatEnum.ADMIN] }],
                [<Business />, 'Organisasjoner', Paths.ORGS.replace('/', ''), { appRoles: [AppRoles.FlatEnum.ADMIN] }],
                [<Assistant />, 'Gi Hjelp', Paths.HELP_MESSAGES.replace('/', ''), { appRoles: [AppRoles.FlatEnum.ADMIN] }],
            ],
            1,
        ],
        //[<Dashboard />, 'Soner', Paths.ZONES.replace('/', '')],
        [<Help />, 'Hjelp/Tilbakemelding', Paths.OWN_HELP_MESSAGES.replace('/', '')],
    ]

    const makeItem = (entry: NavMenuOption | NavMenuSubOption, parent?: NavMenuSubOptions): JSX.Element[] => {
        if(!Array.isArray(entry)){
            return [entry]
        }
        if (isNavMenuOption(entry)) {
            if (openMenus.length && (!parent || !openMenus.includes(parent))) {
                return []
            }
            const [icon, text, path, roles] = entry
            if (!checkOptionAvailable(roles, org, orgUser, appUser)) {
                return []
            }
            return [(
                <ListItem
                    selected={pathname === `/${path}`}
                    button
                    component={Link}
                    to={`/${path}`}
                    //@ts-ignore
                    key={path}
                >
                    <ListItemIcon>{icon}</ListItemIcon>
                    <ListItemText primary={text} />
                </ListItem>
            )]
        }

        const [option, [icon, text, , roles], subOptions, numExtraOptions] = entry

        const isSelected = openMenus.includes(option)
        const toggleOpen = () => isSelected ? setOpenMenus(openMenus.filter(m => m !== option)) : setOpenMenus([...openMenus, option])
        const isAvailable = checkOptionAvailable(roles, org, orgUser, appUser)

        if (!isAvailable || (openMenus.length && !openMenus.includes(option))) {
            return []
        }

        const options = subOptions.reduce((acc, o) => [...acc, ...makeItem(o, option)], [] as JSX.Element[])

        if ((options.length + (numExtraOptions ?? 0)) <= 1 && !openMenus.includes(option)) {
            return options
        }

        return [
            (
                <ListItem
                    button
                    key={option}
                    onClick={toggleOpen}
                >
                    <ListItemIcon>{isSelected ? <ArrowBack /> : icon}</ListItemIcon>
                    <ListItemText primary={text} />
                    {(isSelected || isMini) ? null : (
                        <ListItemSecondaryAction>
                            <IconButton onClick={toggleOpen}>
                                <ChevronRight />
                            </IconButton>
                        </ListItemSecondaryAction>
                    )}
                </ListItem>
            ),
            ...(isSelected ? options : []),
        ]
    }

    return list.map(item => makeItem(item)).flat()
}

type Props = {
    title?: string
    children?: React.ReactNode
    appBar?: JSX.Element
    rightAppBar?: JSX.Element
    bottomAppBar?: JSX.Element
    bottomNavigation?: React.ReactNode
    rightDrawer?: JSX.Element
    rightDrawerIcon?: JSX.Element
    rightDrawerTitle?: string
    rightDefaultOpen?: boolean
    setSearch?: (value: string) => void
    search?: string
    backButton?: React.ReactNode
    loading?: boolean
    loadingScreenId?: string
    backHistoryButton?: boolean
    hasUnsavedChanges?: boolean
    safeUnsavedNavigation?: string[]
    noExtraBottomMargin?: boolean
}

type DrawerProps = {
    side: 'right' | 'left'
    open: boolean
    setOpen: (open: boolean) => void
    children: React.ReactNode
    makeToolbar?: (chevron: React.ReactNode) => React.ReactNode
    isMobile: boolean
}

function SideDrawer({ open, setOpen, children, side, makeToolbar, isMobile }: DrawerProps) {
    const classes = useStyles({});
    const theme = useTheme();

    const handleDrawerToggle = () => {
        setOpen(!open);
    };

    const chevron = (
        <IconButton
            className={classes.blackText}
            aria-label={"close-" + side + "-drawer"}
            onClick={handleDrawerToggle}
        >
            {theme.direction === 'rtl' || side === 'right' ? <ChevronRight /> : <ChevronLeft />}
        </IconButton>
    )

    const toolbar = makeToolbar?.(chevron) || (
        <>
            <div className={classes.toolbar}>{chevron}</div>
            <Divider />
        </>
    )

    if (isMobile) {
        return (
            <SwipeableDrawer
                variant="temporary"
                anchor={side}
                open={open}
                onClose={handleDrawerToggle}
                onOpen={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
            >
                {toolbar}
                {children}
            </SwipeableDrawer>
        )
    }

    return (
        <Drawer
            anchor={side}
            variant="permanent"
            className={clsx(classes.drawer, {
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
            })}
            classes={{
                paper: clsx(classes.drawerPaper, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                }),
            }}
            open
        >
            {toolbar}
            {children}
        </Drawer>
    )
}

type TLeftNavigationDrawer = {
    open: boolean
    openMenus: NavMenuSubOptions[]
}

const emptyArray: any[] = []

function useLeftDrawerState(isMobile: boolean): [TLeftNavigationDrawer, (newState: Partial<TLeftNavigationDrawer>) => void] {
    //This is used for pc and maintains state when link is clicked
    const [drawerState, setDrawerState] = useLocalStorage<TLeftNavigationDrawer>(LocalStorageKeys.LEFT_NAVIGATION_DRAWER, {
        open: !isMobile,
        openMenus: [],
    });

    //This is used for mobile and gets reset when a link is clicked
    const [state, setState] = useState(false);

    return [{
        open: isMobile ? state : drawerState.open,
        openMenus: drawerState.openMenus ?? emptyArray,
    }, ({ open: newOpen, openMenus: newOpenMenus }) => {
        if (newOpen !== undefined) {
            setState(newOpen);
        }
        setDrawerState({
            open: newOpen ?? drawerState.open,
            openMenus: newOpenMenus ?? drawerState.openMenus,
        })
    }];
}

function BoundaryAlert({ resetErrorBoundary, errorMessage }: { resetErrorBoundary: () => void, errorMessage: string }) {
    return (
        <Alert style={{ width: '100%' }} severity="warning">
            {'Oisann! Her skjedde det noe rart. Trykk'}
            <Button color="primary" onClick={resetErrorBoundary}>her</Button>{' for å prøve på nytt eller'}
            <Button color="primary" onClick={() => window.location.reload()}>her</Button>
            {' for å fornye siden: '}
            {errorMessage}
        </Alert>
    )
}

export function PageNavigation({ noExtraBottomMargin, safeUnsavedNavigation, hasUnsavedChanges, backButton, rightAppBar, search, setSearch, children, appBar, bottomAppBar, bottomNavigation, rightDrawer, rightDrawerIcon, title, rightDrawerTitle, rightDefaultOpen, loading, loadingScreenId, backHistoryButton }: Props) {
    const { enqueueSnackbar } = useSnackbar()
    const location = useLocation();
    const history = useHistory()
    const theme = useTheme();
    const [themeString] = useLocalStorage('theme');
    const isDarkTheme = themeString === 'dark';
    // const [userMenuOpen, setUserMenuOpen] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down(responsiveDrawerDeviceSize), { noSsr: true });
    const [{ open: openLeft, openMenus }, setLeftNavState] = useLeftDrawerState(isMobile);
    const [openRight, setOpenRight] = useState(!!rightDefaultOpen || !!(rightDrawer && !isMobile));
    const [appUser] = useAppUser()
    const classes = useStyles({ openLeft, openRight });
    const [org] = useOrg()
    const [orgUser] = useOrgUser()
    const addToHomeScreenContext = useAddToHomeScreen()
    const [orgId] = useOrgIdLocalStorage()
    const [unselectOrg] = useUnselectOrg()
    const [showForceUpdateModal, setShowForceUpdateModal] = useState(false)

    const [showSearch, setShowSearch] = useState(!isMobile || !!search);

    const mini = !isMobile && !openLeft;

    const { isAppInstallable, isAppInstalled, deferredPrompt } = addToHomeScreenContext

    useEffect(() => {
        analytics.setUserProperties({
            appIsInstalled: isAppInstalled,
            appIsInstallable: isAppInstallable,
        })
    }, [isAppInstalled, isAppInstallable])

    useEffect(() => {
        if (hasUnsavedChanges) {
            window.onbeforeunload = () => true
        } else {
            window.onbeforeunload = null
        }
    }, [hasUnsavedChanges])

    const avatar = (
        <Avatar
            style={mini ? { marginLeft: -theme.spacing(0.5) } : {}}
            alt={appUser?.data.contactInfo?.name?.fullName || 'Bruker'}
            src={appUser?.data.avatarImage?.original.url || undefined}
            className={classes.avatar}
        />
    )

    function boundaryFor(boundaryContent: React.ReactNode) {
        return boundaryContent ? (
            <ErrorBoundary onError={(error, info) => {
                analytics.logEvent(AnalyticsEvent.ERROR_BOUNDARY_ACTIVATION, { error, info, appUser, orgUser, org, location, isMobile })
                console.error(error)
                console.error(info)
            }} FallbackComponent={({ resetErrorBoundary, error }) => (
                <BoundaryAlert resetErrorBoundary={resetErrorBoundary} errorMessage={error.message} />
            )}>
                {boundaryContent}
            </ErrorBoundary>
        ) : null
    }

    const installButton = (isAppInstallable && !isAppInstalled) ? (
        <ListItem key="install" button onClick={() => {
            analytics.logEvent(AnalyticsEvent.CLICKED_INSTALL_BUTTON)
            deferredPrompt?.prompt?.()
            deferredPrompt?.userChoice?.then(({ outcome, platform }) => {
                analytics.logEvent(outcome === 'accepted' ? AnalyticsEvent.ACCEPTED_INSTALL_DIALOG : AnalyticsEvent.DECLINED_INSTALL_DIALOG, {
                    outcome,
                    platform,
                    orgId: org?.data.id,
                    orgName: org?.data.name,
                    orgUserId: orgUser?.data.id,
                    appUserId: appUser?.data.id,
                })
            })
        }}>
            <ListItemIcon >
                <GetApp />
            </ListItemIcon>
            <ListItemText primary="Installer Appen" />
        </ListItem>
    ) : null;

    const menuContent = /*!userMenuOpen ?*/[
        (
            <ListItem
                button
                key="Change Organization"
                aria-label="Change Organization"
                selected={location.pathname === Paths.SELECT_ORG}
                onClick={() => {
                    if (orgId) {
                        unselectOrg(AnalyticsEvent.UNSELECTED_ORG)
                    }
                    history.push(Paths.SELECT_ORG)
                }}
            >
                {orgId ? (
                    <ListItemAvatar style={{ marginLeft: -theme.spacing(0.8) }}>
                        <Avatar src={org?.data.logo?.original.url || undefined}>
                            <Business />
                        </Avatar>
                    </ListItemAvatar>
                ) : (
                    <ListItemIcon>
                        <Business />
                    </ListItemIcon>
                )}
                <ListItemText primary={orgId ? noOrgNameText(org?.data.name?.text) : 'Velg organisasjon'} secondary={orgId ? "Trykk her for å bytte" : undefined} />
            </ListItem>
        ),
        ...items(location.pathname, openMenus, openMenus => setLeftNavState({ openMenus }), mini, orgUser?.data, appUser?.data, org?.data),
        installButton,
        ...[
            (appUser?.data.appRoles.map[AppRoles.FlatEnum.DEVELOPER] && openMenus.includes(NavMenuSubOptions.ADMIN)) ? (
                <ListItem key="force update" button onClick={() => {
                    setShowForceUpdateModal(true)
                }}>
                    <ListItemIcon><Publish /></ListItemIcon>
                    <ListItemText primary="Tving oppdatering" />
                </ListItem>
            ) : null,
            (openMenus.includes(NavMenuSubOptions.USER) ? <ListItem key="sign out" button onClick={() => {
                analytics.logEvent(AnalyticsEvent.LOGGED_OUT)
                auth.signOut()
                unselectOrg(AnalyticsEvent.LOGGED_OUT)
            }}>
                <ListItemIcon><ExitToApp /></ListItemIcon>
                <ListItemText primary="Logg Ut" />
            </ListItem> : null),
        ],
    ]

    const searchInput = showSearch && setSearch ? (
        <div className={classes.search}>
            <div className={classes.searchIcon}>
                <Search />
            </div>
            <InputBase
                placeholder="Søk..."
                value={search}
                autoFocus={!search}
                onChange={e => setSearch(e.target.value)}
                onBlur={() => {
                    if ((search === null) || (search === undefined) || (search.replaceAll(' ', '') === '')) {
                        setShowSearch(false)
                    }
                }}
                classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                }}
                inputProps={{ 'aria-label': 'search' }}
            />
        </div>
    ) : null;

    const searchButton = !showSearch && setSearch ? (
        <IconButton color="inherit" aria-label="search" onClick={() => setShowSearch(!showSearch)}>
            <Search />
        </IconButton>
    ) : null

    const content = loading ? <FullscreenLoading screenId={loadingScreenId || 'PageNavigation'} /> : children

    return (
        <div className={classes.root}>
            <CssBaseline />
            {showForceUpdateModal ? (
                <WarningModal
                    title="Tving oppdatering"
                    onCancel={() => setShowForceUpdateModal(false)}
                    onClose={() => {
                        setShowForceUpdateModal(false)
                        analytics.logEvent(AnalyticsEvent.BUMPED_APP_VERSION, { appUser, orgUser, org })
                        db.collection(Collections.APPLICATION_VERSIONS)
                            .doc('Release')
                            .set({ version: firebase.firestore.Timestamp.now() })
                            .then(() => enqueueSnackbar('Vellykket! Alle brukere blir nå oppdatert', { variant: 'success' }))
                            .catch((e) => enqueueSnackbar(e.message, { variant: 'error' }))
                    }}>
                    <Typography variant="subtitle1">Ønsker du å tvinge en oppdatering for alle brukere i appen? Hvis de jobber på noe i dette øyeblikk mister de dette arbeidet!</Typography>
                </WarningModal>
            ) : null}
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: !isMobile && (openLeft || openRight),
                })}
            >
                <Toolbar>
                    {boundaryFor(
                        <>
                            <IconButton
                                color="inherit"
                                aria-label="open left drawer"
                                edge="start"
                                onClick={() => setLeftNavState({ open: !openLeft })}
                                className={clsx(classes.menuButton, {
                                    [classes.hide]: openLeft,
                                })}
                            >
                                <Menu />
                            </IconButton>
                            {backButton}
                            {backHistoryButton ? (
                                <IconButton color="inherit" edge="start" aria-label="go back" onClick={() => history.goBack()}>
                                    <ArrowBack />
                                </IconButton>
                            ) : null}
                            <Typography variant="h6" color="inherit" noWrap>
                                {title}
                            </Typography>
                            {boundaryFor(appBar)}
                            <Box ml="auto">
                                {boundaryFor(searchInput)}
                                {boundaryFor(searchButton)}
                            </Box>
                            {boundaryFor(rightAppBar)}
                            {!!rightDrawer && (
                                <IconButton
                                    color="inherit"
                                    aria-label="open right drawer"
                                    edge="end"
                                    onClick={() => setOpenRight(!openRight)}
                                    className={clsx(classes.menuButton, {
                                        [classes.hide]: openRight,
                                    })}
                                >
                                    {rightDrawerIcon || <Menu />}
                                </IconButton>
                            )}
                        </>
                    )}
                </Toolbar>
            </AppBar>
            {bottomAppBar && (
                <AppBar
                    position="fixed"
                    color="inherit"
                    variant="outlined"
                    className={clsx(classes.appBar, classes.bottomAppBar, {
                        [classes.appBarShift]: !isMobile && (openLeft || openRight),
                    })}
                    style={{ top: 'auto', bottom: 0, border: 'none' }}>
                    {boundaryFor(bottomAppBar)}
                </AppBar>
            )}
            {boundaryFor(
                <SideDrawer
                    side="left"
                    setOpen={open => setLeftNavState({ open })}
                    isMobile={isMobile}
                    open={openLeft}
                    makeToolbar={(chevron) => (
                        <Paper elevation={1} className={classes.toolbarPaper}>
                            {mini && <div className={classes.toolbar} />}
                            <List>
                                {!mini ? (
                                    <>
                                        <ListItem
                                            component={Container}
                                        >
                                            {avatar}
                                            <ListItemSecondaryAction>
                                                <IconButton
                                                    className={classes.blackText}
                                                    aria-label="set-theme"
                                                    onClick={() => writeStorage('theme', isDarkTheme ? 'light' : 'dark')}
                                                >
                                                    {isDarkTheme ? <Brightness7 /> : <Brightness4 />}
                                                </IconButton>
                                                {chevron}
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                        <ListItem
                                            component={Container}
                                        >
                                            <ListItemText
                                                primary={(
                                                    <Typography variant="subtitle1" className={classes.blackText}>
                                                        {noAppUserNameText(appUser?.data.contactInfo?.name?.fullName)}
                                                    </Typography>
                                                )}
                                                secondary={(
                                                    <Typography variant="subtitle2" className={classes.blackText}>
                                                        {noEmailText(appUser?.data.contactInfo?.email?.email)}
                                                    </Typography>
                                                )}
                                            />
                                        </ListItem>
                                    </>
                                ) : (
                                    <ListItem>
                                        {avatar}
                                    </ListItem>
                                )}
                            </List>
                        </Paper>
                    )}
                >
                    <List component="nav" aria-label="main navigation">
                        {boundaryFor(menuContent)}
                    </List>
                </SideDrawer>
            )}
            <Prompt
                when={hasUnsavedChanges || false}
                message={(nextLocation) => {
                    return (
                        (nextLocation.state as any)?.ignoreUnsavedChanges
                        || safeUnsavedNavigation?.includes(nextLocation.pathname)
                        || 'Du har ulagrede endringer, er du sikker på at du vil forlate skjermen?'
                    )
                }}
            />
            <main
                className={clsx(classes.content, {
                    [classes.contentShift]: !isMobile && (openLeft || openRight),
                })}
            >
                <div className={classes.toolbar} />
                {boundaryFor(content)}
                {noExtraBottomMargin ? null : (
                    <div style={{ height: '100px' }} />
                )}
            </main>
            {bottomNavigation ? (
                <BottomNavigation
                    value={location.pathname}
                    showLabels
                    style={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                    }}
                >
                    {bottomNavigation}
                </BottomNavigation>
            ) : null}
            {boundaryFor(rightDrawer && <SideDrawer
                side="right"
                open={openRight}
                setOpen={setOpenRight}
                isMobile={isMobile}
                makeToolbar={!rightDrawerTitle ? undefined : chevron => (
                    <Paper className={clsx(classes.toolbar, classes.toolbarPaper, classes.rightToolbarPaper)}>
                        <Typography variant="h6" className={classes.rightDrawerTitle}>{rightDrawerTitle}</Typography>
                        {chevron}
                    </Paper>
                )}
            >{boundaryFor(rightDrawer)}</SideDrawer>)}
        </div >
    );
}
